import { useEffect } from 'react';
export function useFormMessageEvents(formId, dispatch) {
  useEffect(() => {
    const handleMessage = event => {
      if (event.origin !== window.location.origin) return;
      if (typeof event.data !== 'object' || event.data === null) return;
      const {
        type,
        id,
        eventName
      } = event.data;
      if (type === 'hsFormCallback' && id === formId) {
        dispatch(eventName);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [formId, dispatch]);
}